import { DealRequest } from '@/app/api/types';

export const checkIsContractAndRegistrySentInDeal = (data: DealRequest) =>
  data.debtRegistry &&
  data.factoringContract &&
  (data.status === 'waitingForFactorAcceptance' ||
    data.status === 'waitingForBuyerAcceptance' ||
    data.status === 'completed' ||
    data.status === 'contractCreated' ||
    data.status === 'contractCreatedByFactor' ||
    data.status === 'redeemed' ||
    data.status === 'partiallyRedeemed' ||
    data.status === 'paid' ||
    data.status === 'partiallyPaid' ||
    data.status === 'overdue');

export const checkIsClosedFactoringDeal = (data: DealRequest) =>
  data.factoringType === 'closed';

export const checkIsDealWithoutRegistry = (data: DealRequest) =>
  checkIsClosedFactoringDeal(data) || !!data.isInternational;

export const checkIsDocsSignedInDeal = (data: DealRequest) =>
  !!data.factoringContract?.signers.find((el) => el.actor === 'factor')
    ?.signedAt &&
  !!(
    checkIsDealWithoutRegistry(data) ||
    data.debtRegistry?.signers.find((el) => el.actor === 'factor')?.signedAt
  );

export const checkIsDocsSignedWithOtherSides = (data: DealRequest) =>
  !!data.factoringContract?.signers.find(
    (el) => el.actor === 'buyer' || el.actor === 'seller'
  )?.signedAt &&
  (checkIsDealWithoutRegistry(data) ||
    !!data.debtRegistry?.signers.find(
      (el) => el.actor === 'buyer' || el.actor === 'seller'
    )?.signedAt);
